import i18n from 'i18n-js';

import { scale as initialScale } from '@components/frame';
import { getOperationImageData, getPreferredMachine, getScheduleAdherence } from '@components/search/operations/helpers';
import { IMAGE_WIDTH, IMAGE_HEIGHT } from '@components/search/operations/constants';

import type { StartJobHeaderProps } from '@components/search/operations/components/StartJobPopup/components/StartJobHeader';

export type UseManageStartJobHeaderParams = Pick<StartJobHeaderProps, 'item' | 'scale'>;

export const useManageStartJobHeader = ({ item, scale = initialScale }: UseManageStartJobHeaderParams) => {
  const imgSize = { width: scale(IMAGE_WIDTH), height: scale(IMAGE_HEIGHT) };
  // Image isn't navigable inside the modal, so onPress is a no-op.
  const imageData = {
    ...getOperationImageData({ item, imgSize, onPress: () => {}, contextId: item.productionOperationId }),
    showImageControl: false,
  };

  const preferredMachine = getPreferredMachine(item.machines ?? []);
  const ncFilesCount = item.linkedNcFiles?.length ?? 0;
  const { offsetText, showBehindError } = getScheduleAdherence(item);

  return {
    imageData,
    operationName: item.operationName,
    machineName: preferredMachine?.machineName,
    operationNumber: item.productionOperationNumber,
    ncFilesLabel: `${ncFilesCount} ${i18n.t('NC File')}${ncFilesCount !== 1 ? 's' : ''}`,
    adherenceText: offsetText,
    showBehindError,
    quantityTarget: item.quantityTarget,
  };
};
